export const EKIDEN_API_URL = import.meta.env.VITE_EKIDEN_API_URL;

const getWSUrl = (apiUrl: string | undefined, path: string) => {
  if (!apiUrl) return "";
  try {
    const url = new URL(apiUrl);
    const protocol = url.protocol === "https:" ? "wss:" : "ws:";
    return `${protocol}//${url.host}${path}`;
  } catch {
    return "";
  }
};

export const EKIDEN_WS_URL = getWSUrl(EKIDEN_API_URL, "/ws/public");
export const EKIDEN_PRIVATE_WS_URL = getWSUrl(EKIDEN_API_URL, "/ws/private");
const DEFAULT_SHARE_BASE_URL = "https://app.ekiden.fi";

export const isProduction = import.meta.env.VITE_EKIDEN_API_URL === "https://api.ekiden.fi/api/v1";
export const isEkidenMainnet = typeof window !== "undefined" && window.location.hostname === "app.ekiden.fi";
export const SHARE_BASE_URL =
  import.meta.env.VITE_SHARE_BASE_URL ||
  (typeof window !== "undefined" && window.location.origin ? window.location.origin : DEFAULT_SHARE_BASE_URL);
export const OG_SHARE_SERVICE_URL = import.meta.env.VITE_OG_SERVICE_URL;
export const ENABLE_OG_SHARE = import.meta.env.VITE_ENABLE_OG_SHARE === "true";
export const SHARE_TEMPLATE_VERSION = import.meta.env.VITE_SHARE_TEMPLATE_VERSION || "v1";
export const ROOT_TOKEN_SESSION_KEY = "root_access_token";
export const ROOT_TOKEN_LAST_REQUESTED_KEY = "root_token_last_requested";
export const SUB_ACCOUNT_SESSION_KEY = "sub_accounts";
export const ACTIVE_TRADING_ADDRESS_KEY = "active_trading_address";
export const TERMS_ACCEPTED_KEY = "ekiden-terms-accepted";
export const VAULT_CONTRACT_ADDRESS_KEY = "ekiden-vault-contract-address";
export const GEO_FENCE_BLOCKED_KEY = "restricted";
export const DB_NAME = "ekiden_app_db";
export const DB_STORE_NAME = "ekiden_data";
export const GAS_STATION_API_KEY = import.meta.env.VITE_GAS_STATION_API_KEY;

// Normalized (lowercased) AptosCoin type as returned by indexer balances.
export const APTOS_COIN_INTERNAL =
  "0x0000000000000000000000000000000000000000000000000000000000000001::aptos_coin::aptoscoin";

export const MIN_GAS_PRICE = 100000;

export const IS_APTOS_MAINNET = import.meta.env.VITE_APTOS_NETWORK === "mainnet";
